import { render, staticRenderFns } from "./PostApprovalStatusConfirmSubmit.vue?vue&type=template&id=197c0562&"
import script from "./PostApprovalStatusConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./PostApprovalStatusConfirmSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports